import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect, Provider } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as _ from '../lodash';
import activityPage from '../page/ActivityPage';
import store from '../configureStore';
import { getTimeFrameFromDate } from '../utilities/timeUtility';
import * as productActions from '../actions/products';
import * as frameActions from '../actions/frames';
import * as orderActions from '../actions/orders';
import * as settingActions from '../actions/settings';
import * as cartActions from '../actions/cart';
import { stringToBoolean } from '../utilities/conversionUtility';

const mapStateToProps = ({
  settings, product, order, frames: { frames, ...framesProps },
}) => ({
  frames,
  ...framesProps,
  ...settings,
  locale: window.bta.locale.substr(0, 2),
  isDemo: window.bta.isDemo,
  timeZone: window.bta.timeZone,
  capacityType: product.data.capacity ? product.data.capacity.type : 0,
  minDate: product.data.mindate,
  maxDate: product.data.maxdate,
  variants: product.data.variants,
  locations: product.data.locations,
  seasonalRates: product.data.seasonal_rates,
  hasSeasonalRates: product.data.has_seasonal_rates,
  productOptions: product.data.options,
  maxAvailability: product.maxAvailability,
  totalPrice: order.totalPrice,
  totalQuantity: order.totalQuantity,
  selectedDate: order.date,
  available: order.available,
  orderVariants: order.variants,
  selectedLocation: order.selectedLocation,
  additionalDetails: order.additionalDetails,
  additionalDetailsValidationErrors: order.additionalDetailsValidationErrors,
  selectedTimeslot: order.selectedTimeslot,
});

const mapDispatchToProps = dispatch => ({
  frameActions: bindActionCreators({ ...frameActions }, dispatch),
  orderActions: bindActionCreators({ ...orderActions }, dispatch),
  cartActions: bindActionCreators({ ...cartActions }, dispatch),
  settingActions: bindActionCreators({ ...settingActions }, dispatch),
});

const ActivityPage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(activityPage);

export default class ActivityWidgetContainer extends Component {
  UNSAFE_componentWillMount() {
    let { settings, product, defaultTranslation, exceededTrialPlan, bookingFields } = this.props;

    const newStyle = window.xprops.data && window.xprops.data.style;

    if (newStyle) {
      settings = _.deepMerge(settings, { style: newStyle });
    }

    store.dispatch(
      settingActions.setConfiguration({
        ...settings,
        defaultTranslation,
        exceededTrialPlan,
        bookingFields
      }),
    );

    if (!stringToBoolean(settings.setting.show_timezone_chooser)) {
      store.dispatch(
        settingActions.setLocalTimeZone(window.bta.timeZone)
      );
    }

    // here get data from api originally, later change to get from rails
    store.dispatch(productActions.fetchProduct(product)).then(() => {
      if (window.xprops && window.xprops.onProps) {
        window.xprops.onProps(({ data }) => {
          if (data && data.id) {
            const { id, quantity } = data;
            store.dispatch(orderActions.setVariantsQuantity(`${id}_quantity`, quantity));
          }
        });
      }
    });
  }

  componentDidMount() {
    const { settings, exceededTrialPlan } = this.props;

    const timeZone = stringToBoolean(settings.setting.show_timezone_chooser) ? moment.tz.guess() : window.bta.timeZone;
    // logic of querying timeslot
    // first, we need 2 params: start and finish
    // second, dates must use server timezone to intialize and eventually sent in UTC
    // Start:
    // - should be in server timezone
    const today = new Date();
    const { start, finish } = getTimeFrameFromDate(today, timeZone);

    // Could get the empty data in first time, so use the nextOccurrence to do again

    if (!exceededTrialPlan) {
      store
        .dispatch(
          frameActions.fetchFrames({
            start: start.format(),
            finish: finish.format(),
          }),
        )
        .then(
          framesData => new Promise((resolve) => {
            if (framesData.frames.length === 0) {
              const { nextOccurrence } = framesData;
              if (nextOccurrence) {
                const params = getTimeFrameFromDate(nextOccurrence, timeZone);
                store.dispatch(frameActions.fetchFrames(params)).then((framesData2) => {
                  if (framesData2.frames.length > 0) {
                    resolve(framesData2);
                  } else {
                    resolve(framesData2);
                  }
                });
              } else {
                resolve(framesData);
              }
            } else {
              resolve(framesData);
            }
          }),
        );
    }

    if (window.xprops && window.xprops.onInit) {
      window.xprops.onInit(settings.setting);
    }
  }

  render() {
    return (
      <div>
        <Provider store={store}>
          <ActivityPage />
        </Provider>
      </div>
    );
  }
}

window.changeStyle = value => store.dispatch(settingActions.setStyle(value));
window.changeTranslation = (key, value) => {
  store.dispatch(settingActions.setTranslation(key, value));
};

ActivityWidgetContainer.propTypes = {
  defaultTranslation: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
};
